import React from 'react';
import { Chip } from '@/components/shared/Chip';
import { ChipList } from '@/components/shared/Chip';
import styles from './FilterChipList.module.scss';

export interface FilterChipOption {
	label: string;
	value: string;
}

export interface FilterChipListProps {
	/** Chips to render in order */
	options: FilterChipOption[];
	/** Currently selected value, or null for none selected */
	value: string | null;
	/** Called with the new value on select, or null on deselect (tap selected chip) */
	onChange: (value: string | null) => void;
	/** Enable horizontal scroll (default: true) */
	scrollable?: boolean;
	/** Additional className applied to the ChipList scroll container */
	className?: string;
}

export const FilterChipList: React.FC<FilterChipListProps> = ({
	options,
	value,
	onChange,
	scrollable = true,
	className,
}) => {
	return (
		<ChipList scrollable={scrollable} className={className}>
			{options.map((option) => {
				const isActive = value === option.value;
				return (
					<Chip
						key={option.value}
						variant="rounded"
						selected={isActive}
						className={isActive ? styles['chip--active'] : styles['chip--default']}
						onClick={() => onChange(isActive ? null : option.value)}
					>
						{option.label}
					</Chip>
				);
			})}
		</ChipList>
	);
};

export default FilterChipList;
